<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/delete-icon.svg" alt=""></div>
            <div>
                <h4 class="text-semibold">
                    {{ data?.mode === 'multiple_tasks' ? 'Eliminar tareas' : 'Eliminar tarea' }}
                </h4>
            </div>
            <div>
                <div class="center-svg">
                    <img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt="">
                </div>
            </div>
        </div>
        <div class="mdl-body mt-5">
            <div class="text-center text-light">
                <h5 *ngIf="data?.mode === 'task'">
                    ¿Estás seguro que quieres eliminar la tarea?
                </h5>
                <h5 *ngIf="data?.mode === 'multiple_tasks'">
                    ¿Estás seguro que quieres eliminar estas {{ data?.count }} tareas?
                </h5>
                <p class="color-gray mt-2" *ngIf="data?.mode === 'task' && data?.tarea">
                    "{{ data?.tarea?.titulo }}"
                </p>
                <p class="color-gray mt-2" *ngIf="data?.mode === 'multiple_tasks'">
                    Esta acción no se puede deshacer.
                </p>
            </div>
        </div>
        <hr class="mt-5 mb-5">
        <div class="d-flex flex-row justify-center gap-20 mt-2">
            <button (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
            <button class="btn btn-primary text-center" (click)="delete()">
                {{ data?.mode === 'multiple_tasks' ? 'Eliminar tareas' : 'Eliminar tarea' }}
            </button>
        </div>
    </div>
</div>